import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../../environments/environment";
import {
    SegmentFolderRequest,
    PageResponse,
    SegmentFolder
} from '../models/segment.model';

@Injectable({
    providedIn: 'root'
})
export class FolderApiService {
    private readonly apiUrl = `${environment.apiUrl}api/segments/folders`;

    constructor(private http: HttpClient) { }

    // GET /api/segments/folders (businessId from JWT)
    getFolders(page: number = 0, size: number = 20): Observable<PageResponse<SegmentFolder>> {
        const params = new HttpParams()
            .set('page', page.toString())
            .set('size', size.toString());
        return this.http.get<PageResponse<SegmentFolder>>(this.apiUrl, { params });
    }

    // GET /api/segments/folders/{id}
    getFolderById(id: number): Observable<SegmentFolder> {
        return this.http.get<SegmentFolder>(`${this.apiUrl}/${id}`);
    }

    // POST /api/segments/folders
    createFolder(request: SegmentFolderRequest): Observable<SegmentFolder> {
        return this.http.post<SegmentFolder>(this.apiUrl, request);
    }

    // PUT /api/segments/folders/{id}
    updateFolder(id: number, request: SegmentFolderRequest): Observable<SegmentFolder> {
        return this.http.put<SegmentFolder>(`${this.apiUrl}/${id}`, request);
    }

    // DELETE /api/segments/folders/{id}
    deleteFolder(id: number, deleteSegments = false): Observable<void> {
        const params = deleteSegments ? new HttpParams().set('deleteSegments', 'true') : undefined;
        return this.http.delete<void>(`${this.apiUrl}/${id}`, { params });
    }
}
